import Start from '../pages/onboarding/start.vue';
import Login from '../pages/onboarding/login.vue';
import Register from '../pages/onboarding/register.vue';
import Betteronmobile from '../pages/onboarding/betteronmobile.vue';

import Menu from '../pages/menu.vue';
import Offline from '../pages/offline.vue';

import Home from '../pages/home.vue';
import Explore from '../pages/explore.vue';

import ExploreLearn from '../pages/explore/learn.vue';
import ExplorePlay from '../pages/explore/play.vue';
import ExploreListen from '../pages/explore/listen.vue';
import ExploreAsk from '../pages/explore/ask.vue';
import Search from '../pages/search.vue';
// import ExploreBlog from '../pages/explore/blog.vue';
import Course from '../pages/explore/course.vue';

import Profile from '../pages/profile.vue';

import ProfileBookmarks from '../pages/profile/bookmarks.vue';
import ProfileActivity from '../pages/profile/activity.vue';
import ProfileCompleted from '../pages/profile/completed.vue';

import Blank from '../pages/blank.vue';

import Unit from '../pages/popup/unit.vue';

import courseComplete from '../pages/popup/courseComplete.vue';
import courseNextUp from '../pages/popup/courseNextUp.vue';
import CourseFeedback from '../pages/popup/courseFeedback.vue';

export default [
    {
        path: '/start',
        component: Start
    },
    {
        path: '/betteronmobile',
        component: Betteronmobile
    },
    {
        path: '/onboarding',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/onboarding/onboarding.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/onboarding2',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/onboarding/onboarding2.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/onboarding3',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/onboarding/onboarding3.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/onboarding4',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/onboarding/onboarding4.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/courses/:id/complete',
        component: courseComplete
    },
    {
        path: '/courses/:id/nextup',
        component: courseNextUp
    },
    {
        path: '/subscribeStart',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/subscription/subscribeStart.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/subscribeTerms',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/subscription/subscribeTerms.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/firstTracker',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/popup/firstTracker.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/login',
        component: Login
    },
    {
        path: '/register',
        component: Register
    },
    {
        path: '/home',
        component: Home
    },
    {
        path: '/offline',
        component: Offline
    },
    {
        path: '/explore/',
        alias: '/explore',
        component: Explore,
        tabs: [
            {
                path: '/',
                id: 'tab-1',
                component: ExploreLearn
            },
            {
                path: '/listen',
                id: 'tab-2',
                component: ExploreListen
            },
            {
                path: '/play',
                id: 'tab-3',
                component: ExplorePlay
            },
            {
                path: '/ask',
                id: 'tab-4',
                component: ExploreAsk
            }
            // {
            //     path: '/blog',
            //     id: 'tab-5',
            //     component: ExploreBlog
            // }
        ]
    },
    {
        path: '/profile/',
        alias: '/profile',
        component: Profile,
        tabs: [
            {
                path: '/',
                id: 'ptab-1',
                component: ProfileBookmarks
            },
            {
                path: '/completed',
                id: 'ptab-2',
                component: ProfileCompleted
            },
            {
                path: '/activity',
                id: 'ptab-3',
                component: ProfileActivity
            }
        ]
    },
    {
        path: '/users/:id',
        component: Profile
    },
    {
        path: '/courses/:id/feedback',
        component: CourseFeedback
    },
    {
        path: '/sections/:id',
        component: Course
    },
    {
        path: '/courses/:id',
        component: Course
    },
    {
        path: '/units/:id',
        component: Unit
    },
    {
        path: '/search',
        component: Search
    },
    {
        path: '/activity',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/activity.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/units/:id/comments',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/popup/comments.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/blank',
        component: Blank
    },
    {
        path: '/menu',
        component: Menu
    },
    {
        path: '/settings',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/settings/settings.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/tracker',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/tracker.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/username',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/settings/username.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/ml',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/settings/ml.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/bookmarks',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/bookmarks.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/explore/play/new',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/explore/playNew.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/explore/listen/new',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/explore/listenNew.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/explore/ask/new',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/explore/askNew.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/completedUnits',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/completedUnits.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/admin',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/settings/admin.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/comments/:id',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/popup/comments.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/replies/:id',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/popup/replies.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/traits',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/settings/traits.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/topics/:id',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/explore/topic.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/onboarding/goals',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/onboarding/goals.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/transcript/:id',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/popup/transcript.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/references/:id',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/popup/references.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/goals',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/goals.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/settings/goals',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/settings/goals.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/partners',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/settings/partners.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/subscription/test',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/subscription/test.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/addPartner',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/settings/partnersAdd.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/freeViaPartner',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/subscription/freeViaPartner.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/freeViaPartnerTerms',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/subscription/freeViaPartnerTerms.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/submitStory',
        async(routeTo, routeFrom, resolve, reject) {
            const vueComponent = () => import('../pages/submitStory.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/termsAndConditions',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/settings/termsAndConditions.vue');
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/termsOfUse',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/settings/termsOfUse.vue');
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/settings/preprivacy',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/settings/prePrivacy.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/subscription',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/subscription/manage.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/privacy',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/settings/privacy.vue');
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/about',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/settings/about.vue');
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/data',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/settings/data.vue');
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/help',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/settings/help.vue');
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/journey/:id',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/journey.vue');
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    },
    {
        path: '/faq',
        async(routeTo, routeFrom, resolve, reject) {
            // dynamic import component; returns promise
            const vueComponent = () => import('../pages/settings/faq.vue'); // eslint-disable-line
            vueComponent().then(vc => {
                resolve({
                    component: vc.default
                });
            });
        }
    }
];
